import { types } from 'mobx-state-tree';
import SingleNotification from './SingleNotification';

const NotificationsGroup = types
  .model('notificationsGroup', {
    groupId: types.number,
    name: types.string,
    sort: types.number,
    notifications: types.optional(types.array(SingleNotification), []),
  })
  .views(self => ({
    get getGroupId() {
      return self.groupId;
    },
  }));

export default NotificationsGroup;
